import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { StateService, UIRouter } from '@uirouter/core';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';
import { LoggingService } from '../shared/services/logging/logging.service';
import * as fromStore from '../store';
import * as fromQBO from '../quickbooks/store';
import { AuthenticationService } from './authentication.service';
import { UpdateBearerToken } from './store/auth.actions';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    /**
     *
     */
    constructor(
        private store: Store<fromStore.State>,
        @Inject(LoggingService) private log: LoggingService,
        @Inject(AuthenticationService)
        private authService: AuthenticationService,
        @Inject(StateService) private ss: StateService,
        private router: UIRouter
    ) {}

    public intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Clone the request to add the new header
        const clonedRequest = req.clone({
            // withCredentials: environment.production,
            withCredentials: false,
            setHeaders: {
                Authorization: `Bearer ${this.authService.bearerToken}`
            }
        });

        // Pass the cloned request instead of the original request to the next handle
        // return next.handle(clonedRequest)
        return next.handle(clonedRequest).pipe(
            filter(event => event instanceof HttpResponse),
            // Check for X-New-Token header and update the store if present
            map(event => {
                if (event instanceof HttpResponse) {
                    // Try different case variations of the header name
                    const newToken = event.headers.get('X-New-Token');
                    if (newToken) {
                        this.store.dispatch(new UpdateBearerToken({ token: newToken }));
                    }
                }
                return event;
            }),
            catchError((err, caught) => {

                // we don't want additional 401s to cause us to keep trying to go to the login screen
                if (err.status === 401) {
                    this.log.info({ type: 'AuthInterceptor caught 401' });
                    if (this.authService.bearerToken) {
                        const route = this.ss.current.name;
                        this.authService.logout();
                        this.store.dispatch(new fromStore.SetRedirect(route || ''));
                        this.authService.openDialog();
                        return caught;
                    }
                    this.authService.openDialog();
                }
                // discard 500 errors if we don't have an auth token
                if (err.status >= 500 && err.status < 600) {
                    if (err.status === 511) {
                        this.store.dispatch(new fromQBO.HasValidTokens(false));
                        this.ss.go('main');
                        return EMPTY;
                    }
                    this.log.info({ type: 'AuthInterceptor caught 5xx' });
                    if (this.authService.bearerToken) {
                        throwError(err);
                        throw err;
                    } else {
                        return EMPTY;
                    }
                }
                throwError(err);
                throw err;
            })
        );
    }
}
